export default "__VITE_ASSET__BZkrZuT2__"